import { render, staticRenderFns } from "./setSubCourse.vue?vue&type=template&id=795eea6a&scoped=true&"
import script from "./setSubCourse.vue?vue&type=script&lang=js&"
export * from "./setSubCourse.vue?vue&type=script&lang=js&"
import style0 from "./setSubCourse.vue?vue&type=style&index=0&id=795eea6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795eea6a",
  null
  
)

export default component.exports